
import React from'react';

var SVG=function SVG(){

return(
React.createElement("svg",{viewBox:"0 0 63.57 63.57",role:"img","aria-labelledby":"title  desc"},
React.createElement("title",null,"Close"),
React.createElement("desc",null,"Large black X"),
React.createElement("g",null,
React.createElement("path",{d:"M62.75,56.7,38,32,62.75,7.29a4.28,4.28,0,0,0-6.06-6L32,26,7.31,1.26a4.28,4.28,0,0,0-6.06,6L26,32,1.25,56.71a4.27,4.27,0,0,0,6.06,6L32,38,56.69,62.7a4.28,4.28,0,0,0,6.06-6",transform:"translate(-0.17 -0.24)"}))));




};

export default SVG;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2ljb25zL2Nsb3NlLmpzIl0sIm5hbWVzIjpbIlJlYWN0IiwiU1ZHIl0sIm1hcHBpbmdzIjoiO0FBQ0EsTUFBT0EsTUFBUCxLQUFrQixPQUFsQjs7QUFFQSxHQUFNQyxLQUFNLFFBQU5BLElBQU0sRUFBTTs7QUFFaEI7QUFDRSwyQkFBSyxRQUFRLGlCQUFiLENBQWdDLEtBQUssS0FBckMsQ0FBMkMsa0JBQWdCLGFBQTNEO0FBQ0UseUNBREY7QUFFRSxnREFGRjtBQUdFO0FBQ0UsNEJBQU0sRUFBRSw0S0FBUixDQUFxTCxVQUFVLHdCQUEvTCxFQURGLENBSEYsQ0FERjs7Ozs7QUFVRCxDQVpEOztBQWNBLGNBQWVBLElBQWYiLCJmaWxlIjoiY2xvc2UuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbIlxuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuY29uc3QgU1ZHID0gKCkgPT4ge1xuXG4gIHJldHVybihcbiAgICA8c3ZnIHZpZXdCb3g9XCIwIDAgNjMuNTcgNjMuNTdcIiAgcm9sZT1cImltZ1wiIGFyaWEtbGFiZWxsZWRieT1cInRpdGxlICBkZXNjXCI+XG4gICAgICA8dGl0bGU+Q2xvc2U8L3RpdGxlPlxuICAgICAgPGRlc2M+TGFyZ2UgYmxhY2sgWDwvZGVzYz5cbiAgICAgIDxnPlxuICAgICAgICA8cGF0aCBkPVwiTTYyLjc1LDU2LjcsMzgsMzIsNjIuNzUsNy4yOWE0LjI4LDQuMjgsMCwwLDAtNi4wNi02TDMyLDI2LDcuMzEsMS4yNmE0LjI4LDQuMjgsMCwwLDAtNi4wNiw2TDI2LDMyLDEuMjUsNTYuNzFhNC4yNyw0LjI3LDAsMCwwLDYuMDYsNkwzMiwzOCw1Ni42OSw2Mi43YTQuMjgsNC4yOCwwLDAsMCw2LjA2LTZcIiB0cmFuc2Zvcm09XCJ0cmFuc2xhdGUoLTAuMTcgLTAuMjQpXCIvPlxuICAgICAgPC9nPlxuICAgIDwvc3ZnPlxuICApXG5cbn1cblxuZXhwb3J0IGRlZmF1bHQgU1ZHO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/close.js
// module id = 246
// module chunks = 0